import React from 'react';
import PropTypes from 'prop-types';
import { get, chunk, orderBy } from 'lodash';

const columns = [
  {
    title: 'Neighborhood',
    field: 'neighborhood',
    class: 'w-10',
  },
  {
    title: 'Name',
    field: 'name',
    class: 'w-20',
  },
  {
    title: 'Spouses Name',
    field: 'spouses_name',
    class: 'w-10',
  },
  {
    title: 'Property Address',
    field: 'address',
    class: 'w-20',
  },
  {
    title: 'Home Phone',
    field: 'phone',
    class: 'w-10',
  },
  {
    title: 'Cell Phone',
    field: 'cell_phone',
    class: 'w-10',
  },
  {
    title: 'Email',
    field: 'email',
    class: 'w-10',
  },
];

class ResidentTable extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      page: 0,
      perPage: 25,
      sort: columns[0],
    };
  }

  setPage = page => {
    this.setState({
      page,
    });
  }

  setSort(sort) {
    let dir = sort.dir || 'asc';
    if (sort.title === this.state.sort.title) {
      dir = this.state.sort.dir === 'desc' ? 'asc' : 'desc';
    }
    this.setState({
      sort: { ...sort, dir },
    });
  }

  handleInput = event => {
    const key = event.target.name;
    const value = event.target.value;

    this.setState({
      page: 0,
      [key]: value,
    });
  }

  render() {
    const { residents } = this.props;
    const { page, perPage, search, sort } = this.state;
    const pages = chunk(
      orderBy(residents.filter(resident => (
        !search
        || columns.map(column => get(resident, column.field, '').toString()).join(' ').toLowerCase().includes(search.toLowerCase())
      )), sort.field, sort.dir),
      perPage,
    );

    const firstPageDisplay = page - 5 < 0 ? 0 : page - 5;

    return (
      <div>
        <div className="row">
          <div className="col" />
          <div className="col-4">
            <input className="form-control mb-4" type="text" name="search" onChange={this.handleInput} placeholder="Search" />
          </div>
        </div>
        <table className="table table-sm table-dark table-striped table-hover">
          <thead>
            <tr>
              {
                columns.map(column => (
                  <th className={column.class} key={column.title}>
                    <span role="button" tabIndex="0" onClick={() => this.setSort(column)} style={{ cursor: 'pointer' }}>
                      {column.title} <i className={`fa ${column.title !== sort.title ? 'fa-sort' : `${sort.dir === 'asc' ? 'fa-sort-down' : 'fa-sort-up'}`} `} />
                    </span>
                  </th>
                ))
              }
            </tr>
          </thead>
          <tbody>
            {
              (pages[page] || []).map(resident => (
                <tr key={resident._id}>
                  {
                    columns.map(column => (
                      <td key={column.field}>{get(resident, column.field, '')}</td>
                    ))
                  }
                </tr>
              ))
            }
          </tbody>
        </table>
        <div className="btn-toolbar justify-content-between" role="toolbar">
          <div className="btn-group" role="group">
            <button type="button" className="Btn"><i className="fa fa-chevron-left" /></button>
          </div>
          <div className="btn-group mr-2" role="group">
            {
              pages.slice(firstPageDisplay, firstPageDisplay + 10).map(p => (
                <button
                  type="button"
                  className={`Btn ${pages.indexOf(p) === page ? 'Gold' : ''}`}
                  onClick={() => this.setPage(pages.indexOf(p))}
                  key={`button-${pages.indexOf(p)}`}
                >{pages.indexOf(p) + 1}</button>
              ))
            }
          </div>
          <div className="btn-group" role="group">
            <button type="button" className="Btn"><i className="fa fa-chevron-right" /></button>
          </div>
        </div>
      </div>
    );
  }
}

ResidentTable.propTypes = {
  residents: PropTypes.arrayOf(PropTypes.object),
};

ResidentTable.defaultProps = {
  residents: [],
};

export default ResidentTable;



// WEBPACK FOOTER //
// ./src/bdcoreCandidates/ResidentTable.js